import { Header } from '@/components/DashboardComponents'
import { ActivityGraph } from './ActivityGraph';

export function GlobalActivityGraph({}) {
  return (
    <>
      <Header title="Activity Graph"/>
      <div className="dashboard_content_inner nearest_scrollable_container">
        <div className="dashboard_content_container">
          <ActivityGraph mainPage={true} />
        </div>
      </div>
    </>
  )
}